/*!

 =========================================================
 * Vue Now UI Kit Pro - v1.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/vue-now-ui-kit-pro
 * Copyright 2019 Creative Tim (http://www.creative-tim.com)

 * Designed by www.invisionapp.com Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./registerServiceWorker";
import axios from 'axios'
import VueAxios from 'vue-axios'
//plugins
import NowUIKit from './plugins/now-ui-kit';
import i18n from '@/plugins/i18n';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

import './assets/sass/now-ui-kit.scss'
// // Import Bootstrap an BootstrapVue CSS files (order is important)
// import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false;
Vue.use(NowUIKit, VueAxios);
Vue.use(BootstrapVue, IconsPlugin);
Vue.prototype.$axios = axios
new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount("#app");
